var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "holdRuleGroupView"
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card-title', [_vm._v("Voorwaarden binnen deze groep:")])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('GroupRules', {
    attrs: {
      "rules": _vm.groupData.hold_rules
    }
  })], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button-group', [_vm.hasPermission('holdrules.edit') ? _c('b-button', {
    staticClass: "bg-midnight-bloom text-white",
    on: {
      "click": _vm.editGroup
    }
  }, [_c('i', {
    staticClass: "far fa-pencil mr-1"
  }), _vm._v(" Groep bewerken ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }